import { useAdminAuth } from '../hooks/useAdminAuth';
import { Navigate, Outlet } from 'react-router-dom';

export function AdminLayout() {
  const { isAdmin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-950">
        <div className="text-gray-400">Verifying access...</div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
